import React, { useEffect } from 'react';

const AdBanner = () => {
  useEffect(() => {
    try {
      // Ye code check karta hai ki ad load hui ya nahi
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense Error:", e);
    }
  }, []);

  return (
    <div style={{ margin: "20px 0", textAlign: "center", overflow: "hidden" }}>
        <p style={{ fontSize: "10px", color: "#ccc" }}>Sponsored</p>
        
        {/* ✅ NEECHE APNI ID DALO */}
        <ins className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-7466930762557101"  
            data-ad-slot="4440578851" 
            data-ad-format="auto"
            data-full-width-responsive="true">
        </ins>
    </div>
  );
};

export default AdBanner;